import './Components/GlobalJQuery'

// Import Twitter Bootstrap v4
import 'bootstrap'

// Import webfont Lato
import 'typeface-lato'

// Import global components
import './Components/LazySizes'
import './Components/FontAwesome'
import './Components/SlickCarousel'
import './Components/MediumZoom'
import './Components/Tooltip'
import './Components/SmoothScroll'

// Import atomic components
import '../Fusion/Component/Atom/BackToTop/BackToTop'
import '../Fusion/Component/Atom/StickyContact/StickyContact'
import '../Fusion/Component/Molecule/Carousel/Carousel'
import '../Fusion/Component/Molecule/Navigation/Main/Main'

// Import other packages
import '../../../../Proell.Consent/Resources/Private/JavaScript/Consent'
import '../../../../Proell.Utility/Resources/Private/JavaScript/Utility'
import '../../../../Proell.Search/Resources/Private/JavaScript/Search'
import '../../../../Proell.Product/Resources/Private/JavaScript/Product'
import '../../../../Proell.Product.Property/Resources/Private/JavaScript/Product.Property'
import '../../../../Proell.Address/Resources/Private/JavaScript/Address'
import '../../../../Proell.Form/Resources/Private/JavaScript/Form'

// Styles
import '../Styles/App.scss'
